export default "__VITE_ASSET__BbDZ_Anr__"